export enum SearchDisplayMode {
    NONE = 'NONE',
    PREVIEW = 'PREVIEW',
    FORM = 'FORM',
}
